import { Invoice } from '../../../types';

export function MinimalInvoicePreview({ invoice, company }: { invoice: Invoice, company: any, workspace: any }) {
  return (
    <div className="bg-white mx-auto shadow rounded-2xl p-12" style={{ width: '210mm', minHeight: '297mm', fontFamily: 'Menlo, Monaco, Consolas, monospace' }}>
      <div className="text-2xl font-bold mb-4 tracking-tight">{company.companyName}</div>
      <div className="text-xs text-gray-700 mb-2" style={{ whiteSpace: 'pre-line' }}>{company.address}</div>
      <div className="text-xs text-gray-700 mb-2">Phone: {company.phone}</div>
      <div className="text-xs text-gray-700 mb-2">{company.email}</div>
      <hr className="my-6 border-dashed" />
      <div className="flex mb-4 gap-8">
        <div className="flex-1 text-xs">
          <div className="font-bold uppercase tracking-wider">Invoice</div>
          <div className="text-lg font-mono">{invoice.invoiceNumber}</div>
        </div>
        <div className="flex-1 text-xs text-right">
          <div>Date: <span className="font-semibold">{new Date(invoice.issueDate).toLocaleDateString('en-GB')}</span></div>
          <div>Due: <span className="font-semibold">{new Date(invoice.dueDate).toLocaleDateString('en-GB')}</span></div>
        </div>
      </div>
      <div className="font-bold text-xs mt-6 mb-1 uppercase tracking-wider">Bill To</div>
      <div className="text-xs font-semibold">{invoice.client.name}</div>
      <div className="text-xs">{invoice.client.address}</div>
      <div className="text-xs">{invoice.client.phone}</div>
      <div className="text-xs">{invoice.client.email}</div>
      <hr className="my-6 border-dashed" />
      <div className="grid grid-cols-12 gap-2 text-xs font-bold border-b border-gray-200 pb-2">
        <div className="col-span-6">Description</div>
        <div className="col-span-2 text-center">Rate</div>
        <div className="col-span-2 text-center">Qty</div>
        <div className="col-span-2 text-right">Amount</div>
      </div>
      {invoice.items.map((item, idx) => (
        <div key={item.id} className={`grid grid-cols-12 gap-2 text-xs py-2 ${idx % 2 === 0 ? 'bg-gray-50' : 'bg-white'}`}>
          <div className="col-span-6">{item.description}</div>
          <div className="col-span-2 text-center">{item.rate}</div>
          <div className="col-span-2 text-center">{item.quantity}</div>
          <div className="col-span-2 text-right">{item.amount}</div>
        </div>
      ))}
      <hr className="my-6 border-dashed" />
      <div className="flex justify-end">
        <div className="w-64">
          <div className="flex justify-between text-xs mb-1"><span>Subtotal:</span><span>{invoice.subtotal}</span></div>
          <div className="flex justify-between text-xs mb-1"><span>Tax ({invoice.taxRate}%):</span><span>{invoice.taxAmount}</span></div>
          {invoice.discountAmount > 0 && <div className="flex justify-between text-xs text-green-600 mb-1"><span>Discount:</span><span>-{invoice.discountAmount}</span></div>}
          <div className="flex justify-between text-base font-bold border-t pt-2 mt-2"><span>Total:</span><span>{invoice.total}</span></div>
        </div>
      </div>
      <div className="text-xs text-gray-500 mt-12 text-center">Thank you!</div>
      {/* Signature */}
      {invoice.signature && (
        <div className="mt-10 text-center border-t pt-4 border-gray-200">
          <div className="text-xs text-gray-500 mb-1">Signature</div>
          {invoice.signature.startsWith('http') ? (
            <img src={invoice.signature} alt="Signature" className="mx-auto h-10 object-contain" />
          ) : (
            <div className="italic text-base font-signature text-gray-700" style={{ fontFamily: 'cursive, serif' }}>{invoice.signature}</div>
          )}
        </div>
      )}
    </div>
  );
} 